export default function Footer() {
  const links = {
    product: [
      { label: 'How it works', href: '#how-it-works' },
      { label: 'Download', href: '#download' },
      { label: 'For Bars', href: '#for-bars' },
    ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Contact Us', href: 'https://api.yourmarkerapp.com/public/contactUs.html' },
    ],
    legal: [
      { label: 'Privacy', href: 'https://api.yourmarkerapp.com/public/privacyPolicy.html' },
      { label: 'Terms', href: 'https://api.yourmarkerapp.com/public/T&C.html' },
    ],
  };

  return (
    <footer className="w-full bg-background-100 border-t border-background-200/20">
      <div className="w-full px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/images/logo.png"
                alt="MARKER Logo"
                className="w-8 h-8 rounded-lg object-contain"
              />
              <span className="text-foreground-50 font-bold text-lg tracking-tight">MARKER</span>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-xs">
              The easiest way to buy someone a drink when you are not standing next to them.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-foreground-50 text-sm font-bold mb-4">Product</h4>
            <ul className="space-y-3">
              {links.product.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors"
                    {...(l.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-foreground-50 text-sm font-bold mb-4">Company</h4>
            <ul className="space-y-3">
              {links.company.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors"
                    {...(l.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-foreground-50 text-sm font-bold mb-4">Legal</h4>
            <ul className="space-y-3">
              {links.legal.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors"
                    {...(l.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-background-200/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} MARKER. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-primary-500 transition-colors">
              <i className="ri-instagram-line text-lg" />
            </a>
            <a href="#" className="text-foreground-600 hover:text-primary-500 transition-colors">
              <i className="ri-twitter-x-line text-lg" />
            </a>
            <a href="#" className="text-foreground-600 hover:text-primary-500 transition-colors">
              <i className="ri-linkedin-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}